import { ApiManager } from 'utlis/api_manager';

const userApi = new ApiManager(process.env.REACT_APP_BASE_URL, 1, 'user');

export default class UsersService {
  static async getCollaborators({ search, ...props }) {
    return (await userApi.getByKey('search_user', { search, ...props })).data;
  }
}
